'use client'
import dot  from '@/public/icons/energy-dot.svg'
import Image from 'next/image';
import Marquee from "react-fast-marquee";
import styles from './styles.module.css'

export default function Energy({dict}) {
    return (
        <section className={styles.energy}>
            <Marquee autoFill speed={160} className={styles.energy__marquee}>
                    <div className={styles.energy__title_yellow}>
                        CLEAN
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
                    <div className={styles.energy__title}>
                        ENERGY
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
                    <div className={styles.energy__title_yellow}>
                        SOLUTIONS
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
                    <div className={styles.energy__title}>
                        CLEAN
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
                    <div className={styles.energy__title_yellow}>
                        ENERGY
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
                    <div className={styles.energy__title}>
                        SOLUTIONS
                    </div>
                    <Image className={styles.energy__dot} src={dot} alt='dot'/>
            </Marquee>
        </section>
    );
}